import IComboBoxData from "./IComboBoxData";
class ComboBox {

    // TODO: This should not be public
    public data: IComboBoxData[];

    private combo: HTMLElement | null;
    private caption: HTMLElement | null;
    private search: HTMLInputElement | null;
    private popup: HTMLElement | null;
    private popupList: HTMLElement | null;

    private popupOpen: boolean;

    private selectedID: string | null;
    private initialTop: number;
    private initialLeft: number;
    private subject: string;

    private separatorPos: number;

    constructor() {

        this.combo = null;
        this.caption = null;
        this.search = null;
        this.popup = null;
        this.popupList = null;

        this.data = [];

        this.popupOpen = false;

        this.selectedID = null;
        this.initialTop = 0;
        this.initialLeft = 0;
        this.subject = "";

        this.separatorPos = -1;
    }

    public initData(): void {
        if (this.combo == null) {
            return;
        }
        const jsonData: string | null = this.combo.getAttribute("data-json");
        if (jsonData != null) {
            this.data = JSON.parse(jsonData);
            // extend every item 'hidden' property
            if (this.data != null) {
                for (const row of this.data) {
                    row.Hidden = false;
                    row.DisplayName = row.Name;
                    row.CaptionDisplayName = row.Name;
                }
            } else {
                this.data = [];
                console.error("ComboBox: data is null!");
            }
            //console.log(this.data);
        } else {
            this.data = [
                { ID: "GUID0", Name: "Natúr vintage wood", Hidden: false, DisplayName: "Natúr vintage wood", CaptionDisplayName: "Natúr vintage wood" },
                { ID: "GUID1", Name: "Halifax Fekete Fényes Tölgy", Hidden: false, DisplayName: "Halifax Fekete Fényes Tölgy", CaptionDisplayName: "Halifax Fekete Fényes Tölgy" },
                { ID: "GUID2", Name: "Pasadena fenyő", Hidden: false, DisplayName: "Pasadena fenyő", CaptionDisplayName: "Pasadena fenyő" },
                { ID: "GUID3", Name: "Halifax Fényes Homok Szürke Tölgy", Hidden: false, DisplayName: "Halifax Fényes Homok Szürke Tölgy", CaptionDisplayName: "Halifax Fényes Homok Szürke Tölgy" },
                {
                    ID: "GUID4",
                    Name: "Egger Barna Hegyi Vörösfenyő Aminek Nagyon Hosszú neve van, mert kell a teszt!",
                    Hidden: false,
                    DisplayName: "Egger Barna Hegyi Vörösfenyő Aminek Nagyon Hosszú neve van, mert kell a teszt!",
                    CaptionDisplayName: "Egger Barna Hegyi Vörösfenyő Aminek Nagyon Hosszú neve van, mert kell a teszt!"
                },
            ];
        }
    }

    // rearrange data using the list of IDs to be the first elements
    public rearrange(listOfIDs: string[]): number {
        let compatCount: number = 0;
        const compatList: IComboBoxData[] = [];
        for (const id of listOfIDs) {
            for (const row of this.data) {
                if (row.ID.toLowerCase() === id.toLowerCase()) {
                    if(!row.Hidden) {
                        compatCount++; // need to count compatible non-hidden elements for separator in combo popup
                    }
                    compatList.push(row);
                    break;
                }
            }
        }

        if (compatList.length === 0) {
            return 0;
        }

        // sort compatList based on name, also sort by thickness
        compatList.sort((a, b) => {
            const nameCompare = a.Name.localeCompare(b.Name);
            if (nameCompare !== 0) {
                return nameCompare;
            }
            return a.Thickness! - b.Thickness!;
        });

        const remainderList: IComboBoxData[] = [];
        
        // add the rest of the elements
        for (const row of this.data) {
            if (!listOfIDs.includes(row.ID.toLowerCase())) {
                remainderList.push(row);
            }
        }

        // sort remainderList based on name, also sort by thickness
        remainderList.sort((a, b) => {
            const nameCompare = a.Name.localeCompare(b.Name);
            if (nameCompare !== 0) {
                return nameCompare;
            }
            return a.Thickness! - b.Thickness!;
        });

        // merge the two lists, compatList first, then remainderList, finally assign to this.data
        this.data = compatList.concat(remainderList);

        return compatCount;
    }

    private captionDisplayNameByID(id: string): string {
        for (const row of this.data) {
            if (row.ID.toLowerCase() === id.toLowerCase()) {
                return row.CaptionDisplayName;
            }
        }
        throw "name not found by id: " + id;
    }

    private nameByID(id: string): string {
        for (const row of this.data) {
            if (row.ID.toLowerCase() === id.toLowerCase()) {
                return row.Name;
            }
        }
        throw "name not found by id: " + id;
    }


    private idByLowerCaseName(name: string): string | boolean {
        for (const row of this.data) {
            if (row.Name.toLocaleLowerCase() === name.toLocaleLowerCase()) {
                return row.ID;
            }
        }
        return false;
    }

    private checkPositionChange(): void {
        if (this.combo == null) {
            return;
        }
        const currentRect: DOMRect = this.combo.getBoundingClientRect();
        const currentTop: number = currentRect.top;
        const currentLeft: number = currentRect.left;

        if (currentTop !== this.initialTop || currentLeft !== this.initialLeft) {

            this.positionPopup();

            this.initialTop = currentTop;
            this.initialLeft = currentLeft;
        }
    }

    public init(combo: HTMLElement): void {
        this.combo = combo;
        this.caption = this.combo.querySelector<HTMLElement>(".combo-caption");
        this.search = this.combo.querySelector<HTMLInputElement>(".combo-search");
        this.popup = this.combo.querySelector<HTMLElement>(".combo-popup");
        this.popupList = this.combo.querySelector<HTMLElement>(".combo-popup-list");

        this.subject = "";

        // Initial position
        const initialRect: DOMRect = this.combo.getBoundingClientRect();
        this.initialTop = initialRect.top;
        this.initialLeft = initialRect.left;

        this.initData();

        setInterval(() => {
            this.checkPositionChange(); // Call the method at regular intervals
        }, 100); // Adjust the interval time (in milliseconds) as needed

        this.selectByID(this.data[0].ID);

        ///////////////////////////////////////////
        // click event handler for the combo itself
        ///////////////////////////////////////////
        this.combo.addEventListener("click", () => {
            if (this.popupOpen === false) {
                this.search!.value = this.subject;

                this.filter();
                this.openPopup();

                this.search!.select();
            }
        });

        window.addEventListener("resize", () => {
            this.positionPopup();
        });

        window.addEventListener("scroll", () => {
            this.positionPopup();
        });

        //////////////////////////////////////////////////////////////////////////////////
        // setup a special mousedown event listener to catch click outside of this control
        //////////////////////////////////////////////////////////////////////////////////
        document.addEventListener("mousedown", (event: MouseEvent) => {
            // nested function
            function findElement(element: Element, target: Element) {
                [...element.children].forEach((child) => {
                    if (child == target) {
                        throw child;
                    }
                    findElement(child, target);
                });
            }

            try {
                if (event.target != null) {
                    findElement(combo, (event.target as Element));
                }
                this.closePopup();
            } catch (e) {
                /*we have escaped from the recursive function*/
            }
        });

        ///////////////////
        // handle search //
        ///////////////////
        this.search!.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.code === "Escape" || event.code === "Escape") {
                this.closePopup();
            }

            this.filter();
        }); // end this.search.addEventListener
    }

    public selectByIndex(idx: number): void {
        if (idx < 0 || idx >= this.data.length) {
            console.error("selectByIndex: index out of range: " + idx);
            return;
        }
        this.selectedID = this.data[idx].ID;
        this.caption!.innerHTML = this.captionDisplayNameByID(this.selectedID);
        this.subject = this.nameByID(this.selectedID);
        this.sendEvent();
    }

    public selectByID(id: string): void {
        for (const row of this.data) {
            if (row.ID.toLowerCase() === id.toLowerCase()) {
                this.selectedID = id;
                this.caption!.innerHTML = this.captionDisplayNameByID(this.selectedID);
                this.subject = this.nameByID(this.selectedID);
                this.sendEvent();
                return;
            }
        }
        console.error("selectByID: ID not found: " + id);
    }

    // creates the formatted string and also searches in it then creates highlighting
    private formattedName(row: IComboBoxData, needle: string = ""): string {

        let result: string = row.DisplayName;

        if (needle.length === 0) {
            return result;
        }

        const idx: number = result.toLowerCase().indexOf(needle);
        if(idx !== -1) {
            result = result.substring(0, idx) +
                "<span class=\"highlight\">" +
                result.substring(idx, idx + needle.length) +
                "</span>" +
                result.substring(idx + needle.length);
        }
        
        return result;
    }

    private markAllVisible(): void {
        for (const row of this.data) {
            row.Hidden = false;
        }
    }

    public setSeparatorAt(pos: number): void {
        this.separatorPos = pos;
    }

    private filter(): void {
        console.log("filtering");

        // empty the list
        while (this.popupList!.firstChild) {
            this.popupList!.removeChild(this.popupList!.firstChild);
        }

        const needle: string = this.search!.value.toLocaleLowerCase();
        const id: string | boolean = this.idByLowerCaseName(needle);

        if (id !== false) { // exact match
            let currentElemCnt: number = 0;
            for (var i = 0; i < this.data.length; i++) {
                const row: IComboBoxData = this.data[i];

                // skip hidden rows
                if (row.Hidden) {
                    continue;
                }

                currentElemCnt++;

                const li: HTMLLIElement = document.createElement("li");

                if (needle === row.Name.toLocaleLowerCase()) {
                    li.classList.add("highlight");
                }

                li.setAttribute("attr-id", row.ID);

                li.innerHTML = this.formattedName(row);

                li.addEventListener("click", (event: MouseEvent) => {
                    this.selectByID(row.ID);
                    //this.sendEvent();

                    this.closePopup();
                    event.stopPropagation();
                });

                this.popupList!.appendChild(li);

                if(currentElemCnt === this.separatorPos) {
                    const li: HTMLLIElement = document.createElement("li");
                    li.innerHTML = "<hr>";
                    this.popupList!.appendChild(li);
                }

            }
        } else {
            for (var i = 0; i < this.data.length; i++) {
                const row: IComboBoxData = this.data[i];
                const idx: number = this.formattedName(row).toLocaleLowerCase().indexOf(needle);
                if (idx != -1) {
                    if(row.Hidden) {
                        continue;
                    }
                    const li: HTMLLIElement = document.createElement("li");
                    li.setAttribute("attr-id", row.ID);
                    li.innerHTML = this.formattedName(row, needle); // this provides highlighting

                    li.addEventListener("click", (event: MouseEvent) => {
                        this.selectByID(row.ID);
                        //this.sendEvent();

                        this.closePopup(); // will update caption by selectedID
                        event.stopPropagation();
                    });

                    this.popupList!.appendChild(li);
                }
            }
        }

        if (this.popupList!.children.length === 0) {
            this.popupList!.innerHTML = "<li>Nincs a szűrési feltételeknek megfelelő találat!</li>";
        }

        this.positionPopup();

    } // end filter

    private openPopup(): void {
        if (this.popupOpen === false) {
            console.log("opening popup");
            this.showPopup();
            this.popupOpen = true;
        }
    }

    private showPopup(): void {
        this.combo!.classList.add("active");
        this.positionPopup();
    }

    private closePopup(): void {
        if (this.popupOpen === true) {
            console.log("closing popup");
            this.caption!.innerHTML = this.captionDisplayNameByID(this.selectedID!);
            this.search!.value = "";
            this.hidePopup();
            this.popupOpen = false;
        }
    }

    private hidePopup(): void {
        this.combo!.classList.remove("active");
    }

    public sendEvent(): void {
        // Step 1: Create a custom event
        const customEvent = new CustomEvent("changed", {
            bubbles: true,
            detail: { value: this.selectedID },
        });
        // Step 2: Dispatch the custom event
        this.combo!.dispatchEvent(customEvent);
    }

    private positionPopup(): void {
        if (this.popup == null || this.combo == null) {
            return;
        }
        // unset everything first
        this.popup.style.left = "unset";
        this.popup.style.right = "unset";
        this.popup.style.top = "unset";
        this.popup.style.bottom = "unset";

        const parentRect: DOMRect = this.combo.getBoundingClientRect();
        const parentX: number = parentRect.left + window.scrollX;
        const parentY: number = parentRect.bottom + window.scrollY;

        const popupStyle = window.getComputedStyle(this.popup);

        const marginLeft: number = parseInt(popupStyle.marginLeft);
        const marginRight: number = parseInt(popupStyle.marginRight);
        const marginTop: number = parseInt(popupStyle.marginTop);
        const marginBottom: number = parseInt(popupStyle.marginBottom);

        const width: number = this.popup.offsetWidth + marginLeft + marginRight;
        const height: number = this.popup.offsetHeight + marginTop + marginBottom;

        const viewportWidth: number = window.innerWidth;
        const viewportHeight: number = window.innerHeight;

        /*
        console.log("parentX: " + parentX + ", parentY: " + parentY);
        console.log("popup width: " + width + ", popup height: " + height);
        console.log("viewport: " + viewportWidth + " and " + viewportHeight);
        */

        if (width > viewportWidth) {
            // acnhor left & right
            this.popup.style.left = "0px";
            this.popup.style.right = "0px";
        } else if (parentX + width - marginLeft > viewportWidth) {
            this.popup.style.right = "0px";
        } else {
            this.popup.style.left = `${parentX - marginLeft}px`;
        }

        if (height > viewportHeight) {
            console.log("height > viewportHeight")
            // anchor top & bottom
            this.popup.style.top = "1px";
            this.popup.style.bottom = "0px";
        } else if (parentY + height - marginTop > viewportHeight) {
            this.popup.style.bottom = "0px";
        } else {
            this.popup.style.top = `${parentY - marginTop}px`;
        }
    }
}

export default ComboBox;
